import { Nav, Badge } from "react-bootstrap";
import { BsBell } from "react-icons/bs";
import { useNavigate } from "react-router";
import { routes } from "../../../../app/routes/routes";
import { useGetUnreadCountQuery } from "../../../../app/api/notificationsApi";

const POLLING_INTERVAL = Number(import.meta.env.VITE_NOTIFICATIONS_POLLING_INTERVAL) || 60000;

const NotificationBell: React.FC = () => {
    const navigate = useNavigate();

    const { data: unreadData } = useGetUnreadCountQuery(undefined, {
        pollingInterval: POLLING_INTERVAL,
    });

    const unreadCount = unreadData ?? 0;

    return (
        <Nav.Item className="top-bar-bell-wrapper">
            <Nav.Link onClick={() => navigate(routes.notifications.path)} className="top-bar-bell">
                <BsBell size={20} />
                {unreadCount > 0 && (
                    <Badge pill bg="danger" className="top-bar-bell-badge">
                        {unreadCount > 99 ? "99+" : unreadCount}
                    </Badge>
                )}
            </Nav.Link>
        </Nav.Item>
    );
};

export default NotificationBell;
